export default {
    countryManagement: {
        country_management: 'Country & Region',
        country_list: 'Country list',
        country_hot: 'Hot country',
        country_add: 'Add Country',
        country_id: 'Country ID',
        country_name: 'Country name',
        country_flag: 'Country flag',
        country_number: 'Country number',
        country_room: 'Country room',
        country_region: 'Country region',
        country_code: 'Country code',
        country_details: 'Country details',
        country_details_hot: 'Hot country details',
        country_sort: 'Hot sort',
        country_isShow: 'Show or not',
        country_area: 'Area',

        country_current: 'Current country ',
        country_select: 'Select country',
        country_all: 'All',

        //
        language_ar: 'Arabic area',
        language_en: 'English',
        language_tr: 'Turkish',
        language_hi: 'Indonesian region',
        language_vi: 'Vietnamese',
        language_th: 'Thai',
        language_es: 'Spanish',
        language_in_id: 'Indonesia',
        language_pt: 'Portuguese',
        //
    },
    //金币发放管理
    sendCoins: {
        send_coin_management: "Gold coin distribution management",
        send_coin_management_list: "Gold COINS issued",
        send_tips:"Note: No more than 100 pieces can be distributed at a time, and no more than 5000000 pieces can be distributed at a time. Each person has a limit on the number of gold pieces and the number of props to be distributed each month. Due to the large number of pieces to be distributed in batches, the distribution mode shall be divided into sections, and the distribution shall be completed within five minutes.",
        send_total: "Total number of gold coins sent",
        send_time: "Release time",
        send_operater: "Gold coin issuer",
        send_coins_number: "Number of gold coins issued",
        send_type: "Distribution type",
        send_reason: "Reasons for issuance",
        send_coins: "Issue gold coins",
        send_coins_batch: "Batch distribution",
        send_coins_group: "Group distribution",
        send_coins_prop: "Props distribution",
        send_last_time: "Last release time",
        deduction_coins_batch: "Batch deduction of gold coins",
      send_medal_batch:'Batch room medal distribution',
        record_id: "Record ID",
        recipient: "Gold coin winner",
        recipient_id: "Gold coin winner ID",
        user_no: 'User ID',
        give_coins: "Give away gold coins",
        file_note: "Note that the type of file uploaded is '.xlsx'",
        confirm_distribution: "Confirm distribution",
        select_file: "Please select file",
        file_tip_no: "No file selected",
        file_tip_yes: "Selected file",
        not_xlsx: "This file is not xlsx file, please upload xlsx file",
        download_template: "Download template",
        enter_user_no: "Please enter user number",
        confirmation_deduction: "Confirmation deduction",
        group_label: "Group",
        group_add: "Add group",
        group_index: "S/N",
        group_name: "Group name",
        group_support_users: "Support users",
        group_dispense: "Dispense",
        group_edit: "Edit",
        group_remove: "Remove",
      tab5text1:'Gold subtracter ID',
      tab5text2:'Gold coin deductor',
      tab5text3:'Minus the amount of gold',
      tab5text4:'Deduct the reason',
      tab5text5:'Deduction operator',
      type1:'System recharge (substitute recharge)',
      type2:'The family house',
      type3:'Family support',
      type4:'Activities to reward',
      type5:'Internal issue',
      type6:'Other incentives',
      type7:'',
      type8:'Room support',
      type9:'Outer tube reward',
      type10:'Gold support',
      type23:'Room certification gold support',
      text1:"Note: No more than 200 coins can be distributed at a time, and no more than 300,000 yuan can be distributed at a time. Each person has a limit on the number of gold coins and the number of props to be distributed each month. Due to the large number of coins to be distributed in groups and batches, the distribution shall be completed in five minutes by sections.",
    },

    //活动管理模块 -- 活动管理
    activity_management: {
        ActivityManagement: 'Activity management',
        activity_list: "List of activities",
        regular_activities: 'Regular activities',
        add_regular_activities: 'Add regular activities',
        add_activity: "Add activities",
        edit_activity: "Editing activity",
        weekly_star: 'Zhou Xing activities',
        birthday_star: 'The star of the birthday',
        new_birthday_star: 'New birthday star',
        statistical_region: "Statistical area",
        activity_id: "Activity ID",
        activity_title: "Activity title",
        activity_showPic: "Activity Display icon",
        activity_region: "region",
        activity_url: "Activity in the url",
        activity_startTime: "The start time",
        activity_endTime: "The end of time",
        activity_picture: "Activity Display icon",
        activity_type: "type",
        activity_type_1: "水晶冲榜活动",
        activity_type_2: "个人冲榜活动",
        activity_type_3: "送礼物积分",
        activity_type_4: "普通跳转",
        activity_type_5: "一元夺宝",
        activity_type_6: "情人节冲榜",
        activity_type_7: "魅力冲榜活动",
        activity_type_8: "糖果节活动",
        activity_type_9: "许愿活动",
        activity_type_9: "房间pk活动",
        activity_type_10: "房间pk活动",
        activity_type_11: "个人pk活动",
        activity_type_12: "家族pk活动",
        activity_type_13: "动物庄园",
        // activity_type_14:"cp认证",
        activity_type_15: "cp认证",
        activity_type_16: "战队冲榜",
        activity_type_17: "游戏跳转",
        activity_type_18: "许愿活动",
        activity_type_19: "战鼓pk",
        region_type_1: "all",
        region_type_2: "Other regions [Non-Turkish regions]",
        region_type_3: "Turkish region",
        region_type_4: "Indian region",
        region_type_5: "Vietnam region",
        region_type_6: "In Thai,",
        region_type_9: "Spanish region",
        region_type_10: "Indonesia",
        region_type_11:"Portuguese region",
      region_type_12: "India",

      countryList: "National list",
        gift_points: "Integral gift",
        //
        // 生日之星
        birth_time: "time",
        birth_total_votes: "The total number of votes",
        birth_star_id: "Birthday star ID",
        birth_star_votes: "Birthday star ticket",

      black_list_management:'Blacklist management',

    },
    //
}



// WEBPACK FOOTER //
// ./src/language/j-en.js